import React from 'react'
import  { graphql } from 'gatsby'
import {Helmet} from 'react-helmet'
import Layout from '../../components/Layout'
import CaseStudyHero from '../../components/CaseStudyHero'
import CaseStudyInfo from '../../components/CaseStudyInfo'
import CaseStudyFooter from '../../components/CaseStudyFooter'
import CaseStudyFooterNav from '../../components/CaseStudyFooterNav'
import PresentationRows from '../../components/PresentationRows'
import SEO from '../../components/SEO'
const WorkStudy = ({data}) => {
    console.log(data)

    
    /*
      Set props for each component by pulling from full data object
    */

    const singleData = data.wpWorkStudy.whatWeDoSingle
    const presentationRowData = data.wpWorkStudy.presentationRows
    
    /*
      Get next and previous links and create footer nav props
    */
    const currentPostSlug = data.wpWorkStudy.slug

    // loop through all posts find current post
    const currentPost = data.allWpWorkStudy.edges.filter(post => post.node.slug === currentPostSlug)
    
    const caseStudyFooterNavProps = {
      prevTitle: currentPost[0].previous ? currentPost[0].previous.title : false,
      prevUrl: currentPost[0].previous ? currentPost[0].previous.uri : false,
      nextTitle: currentPost[0].next ? currentPost[0].next.title : false,
      nextUrl: currentPost[0].next ? currentPost[0].next.uri : false
    }
    
    const caseStudyHeroProps = {
      title: data.wpWorkStudy.title,
      photo: {
        altText: singleData.heroWorkImage ? singleData.heroWorkImage.altText : '',
        localFile: singleData.heroWorkImage ? singleData.heroWorkImage.localFile : false
      },
      videoLoop:{
        src: singleData.heroVideo ? singleData.heroVideo : null,
        description: singleData.heroVideoDescription
      },
      videoSingle: {
        videoURL: singleData.heroSingleVideo,
        poster: singleData.heroSingleVideoPoster ? singleData.heroSingleVideoPoster.localFile.publicURL : null,
        altText: singleData.heroSingleVideoPoster ? singleData.heroSingleVideoPoster.altText : null
      },
      slideshow: ''
    }
    const caseStudyInfoProps = {
      approach: singleData.approach,
      challenge: singleData.problem,
      solution: singleData.solution,
      projectSubtitle: singleData.projectSubtitle,
      brandName: singleData.brandName,
      title: data.wpWorkStudy.title,
    }
    const caseStudyFooterProps = {
      brandName: singleData.brandName,
      year: singleData.projectYear,
      touchpoints: singleData.deliverablesV2,
      partners: singleData.creditsV2
    }
    const presentationRowProps = {
        rows: presentationRowData.presentationRows
    }
    const caseSEO = {
      title: data.wpWorkStudy.seo.title ? `Work: ${data.wpWorkStudy.seo.title} | INDUSTRY` : false,
      description: data.wpWorkStudy.seo.description ? data.wpWorkStudy.seo.description : false,
      image: data.wpWorkStudy.seo.socialImage?.localFile.publicURL
    }



    return (
      
        <Layout>
            <Helmet>
                <body data-case="true" />
            </Helmet>
          
            <CaseStudyHero {...caseStudyHeroProps}/>
            {caseStudyInfoProps.solution &&
              <CaseStudyInfo {...caseStudyInfoProps} />
            }
            <div className="presentation-rows-wrapper">
              <PresentationRows {...presentationRowProps} />
            </div>
          
           <CaseStudyFooter {...caseStudyFooterProps} />
          
           <CaseStudyFooterNav {...caseStudyFooterNavProps} />
            
           <SEO
              title= {caseSEO.title}
              description = {caseSEO.description}
              image={caseSEO.image}
            />
            
        </Layout>
        
    )
}

export const query = graphql`
query getSingleWork($slug: String) {
  allWpWorkStudy {
    edges {
      node {
        slug
      }
      next {
        title
        uri
      }
      previous {
        title
        uri
      }
    }
  }
  wpWorkStudy(slug: {eq: $slug}) {
    title
    slug
    seo {
      description
      fieldGroupName
      title
      socialImage {
        localFile {
          publicURL
        }
      }
    }
    whatWeDoSingle {
      approach
      brandName
      creditsV2
      deliverablesV2
      heroVideo
      heroSingleVideo
      heroSingleVideoPoster {
        altText
        localFile {
          publicURL
        }
      }
      heroVideoDescription
      heroWorkImage {
        altText
        localFile {
          childImageSharp {
            gatsbyImageData(
              quality: 80
            )
          }
        }
      }
      mp4AutoplayVideo
      problem
      projectSubtitle
      projectYear
      solution
      heroSlideshow {
        ... on WpWorkStudy_Whatwedosingle_HeroSlideshow_SlideshowImage {
          fieldGroupName
          image {
            altText
            localFile {
              childImageSharp {
                 gatsbyImageData(
                    quality: 80
                  )
              }
            }
          }
        }
        ... on WpWorkStudy_Whatwedosingle_HeroSlideshow_SlideshowVideo {
          fieldGroupName
          video
          posterImage {
            altText
            localFile {
              publicURL
            }
          }
        }
      }
    }
    presentationRows {
      presentationRows {
        ... on WpWorkStudy_Presentationrows_PresentationRows_FullwidthImage {
          fieldGroupName
           image {
            altText
            localFile {
              childImageSharp {
                 gatsbyImageData(
                    quality: 80
                  )
              }
            }
          }
        }
        ... on WpWorkStudy_Presentationrows_PresentationRows_FullwidthVideo {
          fieldGroupName
          videoUrl
          poster {
            altText
            localFile {
              publicURL
            }
          }
        }
        ... on WpWorkStudy_Presentationrows_PresentationRows_VideoPlayer3up{
          fieldGroupName
          videourl1
          poster1 {
            altText
            localFile {
              publicURL
            }
          }
          videourl2
          poster2 {
            altText
            localFile {
              publicURL
            }
          }
          videourl3
          poster3 {
            altText
            localFile {
              publicURL
            }
          }
        }
        ... on WpWorkStudy_Presentationrows_PresentationRows_VideoPlayer23 {
          fieldGroupName
          video
          poster {
            altText
            localFile {
              publicURL
            }
          }
          reversed
        }
        ... on WpWorkStudy_Presentationrows_PresentationRows_FullwidthVideoLoop {
          fieldGroupName
          video
          descriptiveText
        }
        ... on WpWorkStudy_Presentationrows_PresentationRows_FramedImage {
          backgroundColor
          fieldGroupName
          image {
            altText
            localFile {
              childImageSharp {
                gatsbyImageData(
                  quality: 80
                )
              }
            }
          }
        }
        ... on WpWorkStudy_Presentationrows_PresentationRows_FramedVideoLoop {
          backgroundColor
          fieldGroupName
          video
        }
        ... on WpWorkStudy_Presentationrows_PresentationRows_Slideshow {
          fieldGroupName
          slidesToShow
          slideshowV2 {
            ... on WpWorkStudy_Presentationrows_PresentationRows_Slideshow_SlideshowV2_SlideshowImage {
              fieldGroupName
               image {
                altText
                localFile {
                  childImageSharp {
                    gatsbyImageData(
                      quality: 80
                    )
                  }
                }
              }
            }
            ... on WpWorkStudy_Presentationrows_PresentationRows_Slideshow_SlideshowV2_SlideshowVideo {
              fieldGroupName
              video
              posterImage {
                altText
                localFile {
                  publicURL
                }
              }
            }
          }
        }
        ... on WpWorkStudy_Presentationrows_PresentationRows_CopyRow {
          copy
          fieldGroupName
        }
        ... on WpWorkStudy_Presentationrows_PresentationRows_Images1323 {
          fieldGroupName
          imageLeft {
            altText
            localFile {
              publicURL
              childImageSharp {
                gatsbyImageData(
                  quality: 80
                )
              }
            }
          }
          imageRight {
            altText
            localFile {
              publicURL
              childImageSharp {
                gatsbyImageData(
                  quality: 80
                )
              }
            }
          }
        }
        ... on WpWorkStudy_Presentationrows_PresentationRows_Images2313 {
          fieldGroupName
          imageLeft {
            altText
            localFile {
              publicURL
              childImageSharp {
                gatsbyImageData(
                  quality: 80
                )
              }
            }
          }
          imageRight {
            altText
            localFile {
              publicURL
              childImageSharp {
                gatsbyImageData(
                  quality: 80
                )
              }
            }
          }
        }
        ... on WpWorkStudy_Presentationrows_PresentationRows_Images13Space23 {
          fieldGroupName
          imageLeft {
            altText
            localFile {
              publicURL
              childImageSharp {
                gatsbyImageData(
                  quality: 80
                )
              }
            }
          }
          imageRight {
            altText
            localFile {
              publicURL
              childImageSharp {
                gatsbyImageData(
                  quality: 80
                )
              }
            }
          }
        }
        ... on WpWorkStudy_Presentationrows_PresentationRows_Images23Space13 {
          fieldGroupName
          imageLeft {
            altText
            localFile {
              publicURL
              childImageSharp {
                gatsbyImageData(
                  quality: 80
                )
              }
            }
          }
          imageRight {
            altText
            localFile {
               publicURL
              childImageSharp {
                gatsbyImageData(
                  quality: 80
                )
              }
            }
          }
        }
        ... on WpWorkStudy_Presentationrows_PresentationRows_ImageText {
          fieldGroupName
          text
          image {
            altText
            localFile {
              childImageSharp {
                gatsbyImageData(
                  quality: 80
                )
              }
            }
          }
        }
        ... on WpWorkStudy_Presentationrows_PresentationRows_StatsBlocks {
          fieldGroupName
          statBlock {
            fieldGroupName
            stat
            statTitle
          }
        }
        ... on WpWorkStudy_Presentationrows_PresentationRows_23VideoLoop {
          descriptiveText
          fieldGroupName
          video
          image13 {
            altText
            localFile {
              childImageSharp {
                gatsbyImageData(
                  quality: 80
                )
              }
            }
          }
        }
       
          ... on WpWorkStudy_Presentationrows_PresentationRows_23VideoLoopText {
          descriptiveText
          fieldGroupName
          video
          text
        }
        ... on WpWorkStudy_Presentationrows_PresentationRows_13Image23VideoLoop {
          descriptiveText
          fieldGroupName
          video        
          image13 {
            altText
            localFile {
              childImageSharp {
                gatsbyImageData(
                  quality: 80
                )
              }
            }
          }
        }
  
        ... on WpWorkStudy_Presentationrows_PresentationRows_Images3Up {
          fieldGroupName
          image1 {
            altText
            localFile {
              publicURL
              childImageSharp {
                gatsbyImageData(
                  quality: 80
                )
              }
            }
          }
          image2 {
            altText
            localFile {
              publicURL
              childImageSharp {
                gatsbyImageData(
                  quality: 80
                )
              }
            }
          }
          image3 {
            altText
            localFile {
              publicURL
              childImageSharp {
                gatsbyImageData(
                  quality: 80
                )
              }
            }
          }
          vid1
          vid1AltText
          vid2
          vid2AltText
          vid3
          vid3AltText
        }
        ... on WpWorkStudy_Presentationrows_PresentationRows_FullwidthGif {
          fieldGroupName
          image {
            altText
            localFile {
              publicURL
            }
          }
        }
    
        ... on WpWorkStudy_Presentationrows_PresentationRows_FramedVideo {
          fieldGroupName
          video
          posterImage {
            altText
            localFile {
              publicURL
            }
          }
          vertical
        }
        ... on WpWorkStudy_Presentationrows_PresentationRows_VideoText {
          fieldGroupName
          video
          loopVideo
          halfAndHalfLayout
          posterImage {
            altText
            localFile {
              publicURL
            }
          }
          descriptiveText
          text
        }
        ... on WpWorkStudy_Presentationrows_PresentationRows_13VideoLoop23VideoLoop {
          fieldGroupName
          video13
          video13Description
          video23
          video23Description
        }
        ... on WpWorkStudy_Presentationrows_PresentationRows_23VideoLoop13VideoLoop {
          fieldGroupName
          video13
          video13Description
          video23
          video23Description
        }
         ... on WpWorkStudy_Presentationrows_PresentationRows_Image2Videoloop1 {
          space
          reverse
          fieldGroupName
          video
          descriptiveText
          image2 {
            altText
            localFile {
              childImageSharp {
                gatsbyImageData(
                  quality: 80
                )
              }
            }
          }
        }
      }
    }
  }
}
`

export default WorkStudy
